
  import createMeisterIcons from '../src/createMeisterIcons';

  const Square14 = createMeisterIcons("square-14", [["path",{"fill":"currentColor","d":"M7 3.75A3.26 3.26 0 0 0 3.75 7v4.25h7.5v-7.5zm4.25 9h-7.5V17c0 1.798 1.376 3.25 3.25 3.25h4.25zm1.5 0h7.5V17A3.26 3.26 0 0 1 17 20.25h-4.25zm7.5-1.5h-7.5v-7.5H17A3.26 3.26 0 0 1 20.25 7zM2.25 7A4.76 4.76 0 0 1 7 2.25h10A4.76 4.76 0 0 1 21.75 7v10A4.76 4.76 0 0 1 17 21.75H7c-2.726 0-4.75-2.148-4.75-4.75z","key":"4ff8c81ec4f197bf74ab8e6fa277141af2d42aab","fillRule":"evenodd","clipRule":"evenodd"}]])

  export default Square14
  